// PayOrder.tsx
import PayOrderBase from './PayOrderBase';
import PayOrderEdit from './PayOrderEdit';
import WxPayOrderEdit from './wxPay/WxPayOrderEdit';
import WxPayRefundOrder from './wxPay/WxPayRefundOrder';

const PayOrder = (props: any) => (
    <PayOrderBase
        apiId="payOrder"
        wxPayOrderApiId="wxPayOrder"
        titleName="支付订单"
        PayOrderEditComponent={PayOrderEdit}
        WxPayOrderEditComponent={WxPayOrderEdit}
        WxPayRefundOrderComponent={WxPayRefundOrder}
        outerProps={props}
    />
);

export default PayOrder;